/* eslint-disable @typescript-eslint/no-shadow */
import clsx from 'clsx';
import React from 'react';
import { NavLink } from 'react-router-dom';

const navigation: NavigationOption[] = [
  {
    name: 'Users',
    path: '/users',
  },
  {
    name: 'Organizations',
    path: '/organizations',
  },
  {
    name: 'Conferences',
    path: '/conferences',
  },
  {
    name: 'Resources',
    path: '/behavior-config',
  },
  {
    name: 'QIP Metrics',
    path: '/behavior-config/qip-metric-builder/questions',
  },
  {
    name: 'Guidelines',
    path: 'behavior-config/guidelines',
  },
];

interface NavigationOption {
  name: string;
  path?: string;
  children?: NavigationOption[];
}

export const NavigationV2 = () => (
  <nav className="w-[320px] text-zinc-800 text-lg bg-zinc-100">
    <ul className="flex flex-col pt-10">
      {navigation.map((route) => (
        <li key={route.name} className="">
          <NavigationLink name={route.name} path={route.path || ''} />
        </li>
      ))}
    </ul>
  </nav>
);

interface NavigationLinkProps {
  path: string;
  name: string;
}

const NavigationLink = ({ path, name }: NavigationLinkProps) => (
  <NavLink
    end
    to={path.toLocaleLowerCase()}
    className={({ isActive }) =>
      clsx('w-full pl-6 pb-8 flex items-center font-bold', isActive && 'font-normal')
    }
    data-cy={`nav-item-${path.replace('/', '')}`}>
    {name}
  </NavLink>
);
